"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var getAlignOffset_1 = tslib_1.__importDefault(require("./getAlignOffset"));
function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
    var p1 = (0, getAlignOffset_1.default)(refNodeRegion, points[1]);
    var p2 = (0, getAlignOffset_1.default)(elRegion, points[0]);
    var diff = [p2.left - p1.left, p2.top - p1.top];
    return {
        left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
        top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1]),
    };
}
exports.default = getElFuturePos;
//# sourceMappingURL=getElFuturePos.js.map